import React, { Component } from "react";

import { Redirect } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import QrReader from "react-qr-reader";

import Button from "../../components/standard/Button";
import InputField from "../../components/standard/InputField";
import Error from "../../components/standard/Error/Error";

import "./TableCode.css";
import sendRequest from "../../services/APICall";

class TableCode extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: "",
      delay: 1000,
      result: "No result",
      loading: false,
      code: null,
    };

    this.handleQRScan = this.handleQRScan.bind(this);
    this.openImageDialog = this.openImageDialog.bind(this);

    // Create ref for QR code component
    this.qrRef = React.createRef();

    const username = localStorage.getItem("username");

    if (!username) {
      window.location.pathname = "/";
    }
  }

  componentDidMount() {
    document.body.addEventListener("keypress", (e) => {
      var key = e.which || e.keyCode;
      if (key === 13) {
        // 13 is enter
        if (!this.state.code) {
          alert("Voucher code can't be empty!");
        }
        this.handleQRScan(this.state.code);
      }
    });
  }

  // Checks if browser is compaitable to scan qr code.
  isNotCompaitable() {
    let userAgent = window.navigator.userAgent;
    let isSafari =
      navigator.vendor &&
      navigator.vendor.indexOf("Apple") > -1 &&
      navigator.userAgent &&
      navigator.userAgent.indexOf("CriOS") === -1 &&
      navigator.userAgent.indexOf("FxiOS") === -1;

    // Return yes if safari
    if (isSafari) {
      return false;
    }

    // Return true iphone
    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
      return true;
    } else {
      var isChrome =
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor);
      if (!isChrome) {
        return true;
      }
      return false;
    }
  }

  // Method to handle succesfull scan.
  handleQRScan(data) {
    if (data) {
      const payload = {
        code: data,
      };

      const token = localStorage.getItem("email");

      if (!this.state.loading) {
        this.setState({ loading: true });

        sendRequest("/api/v1/voucher/redeem", payload, token)
          .then((response) => response.json())
          .then((res) => {
            if (res.tourName) {
              alert("Ticket valid for " + res.tourName);
            } else {
              alert(res.message);
            }
            this.setState({ loading: false, code: null });
          })
          .catch((error) => {
            alert("Some problem in scanning, please try again later" + error);
            this.setState({ loading: false, code: null });
          });
      }
    }
  }

  handleError(err) {
    alert("Some error occurred in scanning" + err);
  }

  submitButton() {
    if (!this.state.code) {
      alert("Voucher code can't be empty!");
    }
    this.handleQRScan(this.state.code);
  }

  // OnsubmitQRCode handler for Next button.
  submitQRCode() {
    window.mixpanel.track("Submit Code");
    var table_code = this.state.table_id || "";
    if (table_code.length === 4) {
      this.setState({ redirect: true });
    } else {
      this.setState({ error: true });
    }
  }

  // Key event handler to sync data between input component and scree.
  handleChangeValue = (e) => {
    var text = e.target.value;

    this.setState({ code: text.toUpperCase() });
  };

  // Open image dialog to scan QR in non supported browser.
  openImageDialog() {
    this.qrRef.current.openImageDialog();
  }

  render() {
    // Redirect to menu after valid table code
    if (this.state.redirect) {
      return <Redirect push to={"/menu/" + this.state.table_id} />;
    }
    var isCompatible = this.isNotCompaitable();
    var that = this;

    if (window.screen.width > 700) {
      return (
        <div className="desktop-table-code">
          <img
            src={
              "https://cdn-imgix-open.headout.com/logo/svg/Headout_logo_purps.svg?w=300&h=50&fit=fill"
            }
            className="headout-logo"
            alt="Headout's logo"
          />

          <div className="desktop-text">Ticket scanning app</div>

          <InputField
            type="text"
            placeholder="Enter voucher code"
            value={this.state.code}
            onChangeValue={this.handleChangeValue}
            style="text-transform: uppercase"
          />

          <br />

          <Button
            align="center"
            color="Purps"
            text="submit"
            type="non-network"
            onClickEvent={this.submitButton.bind(this)}
            border
          />
        </div>
      );
    }
    return (
      <div className="Table-code">
        <div className="Top-bar">
          <div className="Background"></div>
          <div className="Topbar-content">
            <div className="Logo-section">
              <div className="Sveet-logo">
                <img
                  src={
                    "https://cdn-imgix-open.headout.com/logo/svg/Headout_logo_purps.svg?w=300&h=50&fit=fill"
                  }
                  className="headout-logo"
                  alt="Headout's logo"
                />
              </div>
              <div className="Logo-text">Ticket scanning app</div>
            </div>
            <div className="QR-Section">
              <div
                className={
                  isCompatible ? "QR-Scanner Qr-Click-Scanner" : "QR-Scanner"
                }
              >
                {isCompatible ? (
                  <div
                    className="Qr-code"
                    onClick={() => {
                      this.openImageDialog();
                    }}
                  >
                    <img
                      src={require("../../assets/images/icons/photo-camera.svg")}
                      className="Camera-icon"
                      alt="Camera icon"
                    />
                  </div>
                ) : (
                  ""
                )}
                <div className="Scanner-stick"></div>
                <QrReader
                  ref={this.qrRef}
                  delay={this.state.delay}
                  onError={this.handleError}
                  legacyMode={isCompatible ? true : false}
                  className="Qr-scanner-component"
                  onScan={this.handleQRScan}
                  style={{ width: "100%" }}
                />
              </div>
              <div className="QR-Scanner-text">
                {isCompatible ? "Click above to scan Qr Code" : "Scan QR code"}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// Connects this state and App.jsx redux calls and data passing
export default TableCode;



// WEBPACK FOOTER //
// ./src/screens/TableCode/TableCode.jsx